// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tsT7","left":"styles_left__1AGvw","right":"styles_right__1TJd-","alert":"styles_alert__1pJag"};